<template>
  <navbar
    position="fixed"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template>
    </template>
    <template slot="navbar-menu">
      <li class="nav-item">
        <nav-link
          class="nav-link"
          to="/home"
        >
          Home
        </nav-link>
      </li>
      <li class="nav-item">
        <nav-link
          class="nav-link"
          to="/loesungen"
        >
          Lösungen
        </nav-link>
      </li>
      <li class="nav-item">
        <nav-link
          class="nav-link"
          to="/pricing"
        >
          Preise
        </nav-link>
      </li>
      <li class="nav-item">
        <nav-link
            class="nav-link btn btn-primary"
            to="/contact"
        >
          <p>Jetzt anfragen</p>
        </nav-link>
      </li>
    </template>
  </navbar>
</template>

<script>
  import { DropDown, Navbar, NavLink } from '@/components';
  import { Popover } from 'element-ui'
  export default {
    name: 'MainNavbar',
    components: {
      DropDown,
      Navbar,
      NavLink,
      [Popover.name]: Popover
    },
    props: {
      transparent: Boolean,
      colorOnScroll: Number,
    }
  }
</script>

<style scoped>

</style>
